import S_base from '@/services/wasaapi/__base';

export default {
  async delete(articleId) {
    try {
      await S_base.delete({ modelName: 'article', modelId: articleId });
    } catch (error) {
      alert(error);
    }
  },
};
